<template>
  <div class="px-2 md:px-6">
    <h1 class="font-semibold mb-6 text-center text-xl lg:text-2xl">
      Promote You
    </h1>
    <div class="flex items-center flex-col md:flex-row">
      <img
        v-if="event.owner.avatar"
        :src="event.owner.avatar"
        alt="BuildaBox Promote Modal"
        class="w-20 h-20 rounded-full cursor-pointer border mr-4 object-cover flex-shrink-0"
      />
      <img
        v-else
        src="@/assets/images/default-avatar.png"
        alt="BuildaBox Promote Modal"
        class="w-20 h-20 rounded-full cursor-pointer border mr-4 object-cover flex-shrink-0"
      />
      <div class="font-semibold text-center md:text-left">
        Hey {{ authUser.firstName }}! Important people build boxes.
        Your friends and associates won't know, if you don't tell them.
      </div>
    </div>
    <fieldset class="mt-4">
      <label for="message"></label>
      <textarea class="textarea mt-2 resize-none" id="message" v-model="message" />
    </fieldset>
    <div class="flex flex-col md:flex-row items-center justify-between mt-5">
      <button v-if="event.facebook_link"
              class="btn btn-facebook font-semibold rounded-lg px-10 mb-3 w-full md:w-auto mx-auto"
              @click="onFacebook">
        <img src="@/assets/images/ic_facebook.svg" alt="" class="inline-block w-6 h-6" />
        Facebook
      </button>
      <button v-if="event.twitter_link"
              class="btn btn-twitter font-semibold rounded-lg px-10 mb-3 w-full md:w-auto mx-auto"
              @click="onTwitter">
        <img src="@/assets/images/ic_twitter.svg" alt="" class="inline-block w-6 h-6" />
        Twitter
      </button>
      <button v-if="event.linkedin_link"
              class="btn btn-linkedin font-semibold rounded-lg px-10 mb-3 w-full md:w-auto mx-auto"
              @click="onLinkedIn">
        <img src="@/assets/images/ic_linkedin.svg" alt="" class="inline-block w-6 h-6" />
        LinkedIn
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      event: Object
    },
    data() {
      return {
        message: ''
      }
    },
    computed: {
      authUser() {
        return this.$store.state.auth.user
      }
    },
    mounted() {
      this.message = `Building a box for ${this.event.name}. I'm exited to attend!`
    },
    methods: {
      onFacebook() {
        window.open(`https://www.facebook.com/sharer.php?u=${this.event.facebook_link}`)
      },
      onTwitter() {
        window.open(`https://twitter.com/intent/tweet?text=${this.message}&url=${this.event.twitter_link}`)
      },
      onLinkedIn() {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${this.event.linkedin_link}`)
      }
    }
  }
</script>

<style scoped>
  .btn-facebook {
    background-color: #3C5998;
    color: white;
  }

  .btn-twitter {
    background-color: #1BA2F2;
    color: white;
  }

  .btn-linkedin {
    background-color: #0E76A8;
    color: white;
  }
</style>